var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable",on:{"click":_vm.onGroupRemove}},[_c('i',{staticClass:"mdi mdi-close-circle-outline"}),_vm._v("\n  Eliminar grupo\n")])}
var staticRenderFns = []

export { render, staticRenderFns }